

import React from 'react';
import './Precios.css';
import { Link } from 'react-router-dom';
import { sendEvent } from "../utils/ga4";
import { sendMetaEvent } from "../utils/metaPixel";


function Precios() {
  return (
    <section id="pricing">
    <div className="precios-section">
      <div className="precio-card profesional">
        <div className="titulo"> 
        <h3>Plan Profesional</h3>
        </div>
        <p className="precio">$169 <span className="precio-detalle">MXN / mes</span></p>
        <p>Perfecto para profesionales que buscan gestionar sus consultas de manera eficiente y sin límites.</p>
        <ul>
          <li>Historia clínica completa</li>
          <li>Agendamiento de citas ilimitado</li>
          <li>Recetas digitales</li>
          <li>Seguridad en AWS</li>
        </ul>
      </div>
      <div className="precio-card gratuito">
        <div className="titulo">  
        <h3>Plan Profesional Anual</h3>
        </div>
        <p className="precio">$1690 <span className="precio-detalle">MXN / año</span></p>
        <p>La opción ideal para ahorrar y asegurar acceso completo todo el año.</p>
        <ul>
          <li>Todo lo del plan mensual</li>
          <li>+ Ahorro equivalente a 2 meses</li>
          <li>+ Prioridad en soporte</li>
        </ul>
      </div>
    </div>
    
    <div className="boton-unico">
      <Link
        to="/registro"
        onClick={() => {
          sendEvent({
            category: "Home",
            action: "Registro_desde_sección_precios",
            label: "RegistroPrecios",
          });

          // Meta Pixel — Lead
          sendMetaEvent("Lead");
        }}
      >
        <button>Comenzar ahora</button>
        </Link>
      </div>
    </section>
  );
}

export default Precios;


